var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getRoomDisplayName } from './roomDisplayName';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { _T } from '../../../include/appI18n';
import { showErrorDialog } from '../../../include/common';
import { api } from '../../../include/network/network';
import { formatMoney, pluralizeAutoSplit } from '../../../include/utils';
import { useCartOrder } from './CartOrder';
import { ServiceTouristsBlock } from './ServiceTouristsBlock';
import { getHotelDescriptionPageUrl } from './servicePageLinks';
const getCompulsoryServiceRules = (service) => { var _a; return (_a = service === null || service === void 0 ? void 0 : service._rules) !== null && _a !== void 0 ? _a : service; };
const getServiceDefinition = (service) => {
    const rules = getCompulsoryServiceRules(service);
    return {
        id: rules.id,
        classId: rules.serviceClassId,
        name: rules.name,
    };
};
const getChoiceKey = (choice) => `${choice.id}|${choice.classId}|${moment(choice.validOnIso).format('YYYY-MM-DD')}|${choice.duration}`;
const normalizeServicePrice = (price) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const id = (_a = price.id) !== null && _a !== void 0 ? _a : price.Id;
    const classId = (_b = price.classId) !== null && _b !== void 0 ? _b : price.ClassId;
    const validOnIso = (_c = price.validOnIso) !== null && _c !== void 0 ? _c : price.ValidOnIso;
    const duration = (_d = price.duration) !== null && _d !== void 0 ? _d : price.Duration;
    if (id === undefined || classId === undefined || !validOnIso || duration === undefined)
        return undefined;
    return {
        id,
        classId,
        price: (_f = (_e = price.price) !== null && _e !== void 0 ? _e : price.Price) !== null && _f !== void 0 ? _f : '',
        currency: (_h = (_g = price.currency) !== null && _g !== void 0 ? _g : price.Currency) !== null && _h !== void 0 ? _h : '',
        validOn: (_k = (_j = price.validOn) !== null && _j !== void 0 ? _j : price.ValidOn) !== null && _k !== void 0 ? _k : moment(validOnIso).format('L'),
        validOnIso,
        duration,
    };
};
function HotelCompulsoryServicesDialog(props) {
    const cartOrder = useCartOrder();
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [groups, setGroups] = useState([]);
    const [selected, setSelected] = useState({});
    const definitions = useMemo(() => { var _a; return ((_a = props.hotelService.hotelPrice.compulsoryServices) !== null && _a !== void 0 ? _a : []).map(getServiceDefinition); }, [props.hotelService.hotelPrice.compulsoryServices]);
    const hasAlternatives = useMemo(() => props.compulsoryServices.some(current => {
        const rules = getCompulsoryServiceRules(current.compulsoryService);
        return !!rules && definitions.filter(x => x.classId == rules.serviceClassId).length > 1;
    }), [definitions, props.compulsoryServices]);
    const dialogKey = useMemo(() => `cart-hotel-compulsory-services:${props.hotelService.serviceTag}:${props.compulsoryServices.map(x => x.serviceVersion).join(',')}`, [props.hotelService.serviceTag, props.compulsoryServices]);
    const loadGroups = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        var _a;
        if (!hasAlternatives)
            return;
        setLoading(true);
        setOpen(true);
        const accommodation = props.hotelService.accommodation;
        const { response, errors } = yield api('get', 'Hotel/GetCompulsoryServicePrices', {
            hotelId: props.hotelService.hotelPrice.hotelId,
            currencyId: props.cart.booking.currency.id,
            checkIn: props.hotelService.begin,
            checkOut: props.hotelService.end,
            services: definitions.map(x => ({ id: x.id, classId: x.classId })),
            rooms: [{
                    callerGeneratedId: 0,
                    quantity: 1,
                    adultBuyers: accommodation.adults,
                    childBuyers: accommodation.childAccommodations.slice(0, accommodation.childs).map(x => x.age),
                }],
        });
        if ((errors === null || errors === void 0 ? void 0 : errors.length) || !response) {
            setLoading(false);
            showErrorDialog((_a = errors === null || errors === void 0 ? void 0 : errors[0]) !== null && _a !== void 0 ? _a : 'Не удалось загрузить обязательные услуги');
            return;
        }
        const nextGroups = props.compulsoryServices.map(current => {
            var _a, _b;
            const currentDefinition = getServiceDefinition(current.compulsoryService);
            const classDefinitions = definitions.filter(x => x.classId == currentDefinition.classId);
            const currentDuration = Math.max(1, moment(current.end).startOf('day').diff(moment(current.begin).startOf('day'), 'days'));
            const currentChoice = Object.assign(Object.assign({}, currentDefinition), { validOn: moment(current.begin).format('L'), validOnIso: current.begin, duration: currentDuration, price: current.priceInBookingCurrency.toFixed(2), currency: props.cart.booking.currency.name });
            const choices = ((_b = (_a = response.servicePrices) !== null && _a !== void 0 ? _a : response.ServicePrices) !== null && _b !== void 0 ? _b : [])
                .map(normalizeServicePrice)
                .filter((price) => !!price)
                .filter(price => classDefinitions.some(x => x.id == price.id && x.classId == price.classId))
                .map(price => {
                var _a, _b;
                return (Object.assign(Object.assign({}, price), { name: (_b = (_a = classDefinitions.find(x => x.id == price.id && x.classId == price.classId)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '' }));
            });
            const originalKey = getChoiceKey(currentChoice);
            if (!choices.some(choice => getChoiceKey(choice) == originalKey))
                choices.unshift(currentChoice);
            return { current, choices, originalKey };
        }).filter(group => group.choices.length > 0);
        setGroups(nextGroups);
        setSelected(Object.fromEntries(nextGroups.map(group => [
            getCompulsoryServiceRules(group.current.compulsoryService).serviceClassId.toString(),
            group.originalKey,
        ])));
        setLoading(false);
    }), [definitions, hasAlternatives, props.cart.booking.currency, props.compulsoryServices, props.hotelService]);
    useEffect(() => {
        if (!hasAlternatives)
            return;
        try {
            if (sessionStorage.getItem(dialogKey) == '1')
                return;
            const dialogWindow = window;
            if (dialogWindow.__cartHotelCompulsoryDialogClaimed)
                return;
            dialogWindow.__cartHotelCompulsoryDialogClaimed = true;
            sessionStorage.setItem(dialogKey, '1');
            void loadGroups();
        }
        catch (_a) {
        }
    }, [dialogKey, hasAlternatives, loadGroups]);
    const save = () => __awaiter(this, void 0, void 0, function* () {
        const changes = groups.map(group => {
            const classId = getCompulsoryServiceRules(group.current.compulsoryService).serviceClassId.toString();
            const selectedChoice = group.choices.find(choice => getChoiceKey(choice) == selected[classId]);
            return selectedChoice && getChoiceKey(selectedChoice) != group.originalKey
                ? { group, selectedChoice }
                : undefined;
        }).filter((x) => !!x);
        if (!changes.length) {
            setOpen(false);
            return;
        }
        setSaving(true);
        for (const change of changes) {
            const { errors } = yield api('post', 'Cart/ChangeHotelCompulsoryService', {
                returnJson: true,
                serviceTag: props.hotelService.serviceTag,
                id: change.selectedChoice.id,
                classId: change.selectedChoice.classId,
                serviceActivationDate: change.selectedChoice.validOnIso,
                serviceDuration: change.selectedChoice.duration,
            });
            if (errors === null || errors === void 0 ? void 0 : errors.length) {
                showErrorDialog(errors[0]);
                setSaving(false);
                return;
            }
        }
        yield cartOrder.refresh();
        setSaving(false);
        setOpen(false);
    });
    if (!hasAlternatives)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement("a", { href: "#", className: "link", onClick: e => {
                e.preventDefault();
                void loadGroups();
            } }, "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C"),
        React.createElement(Dialog, { open: open, onClose: () => !saving && setOpen(false), maxWidth: "md", fullWidth: true },
            React.createElement(DialogTitle, null, "\u0412\u044B\u0431\u043E\u0440 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u0434\u043E\u043F. \u0443\u0441\u043B\u0443\u0433"),
            React.createElement(DialogContent, null, loading ? React.createElement(CircularProgress, { size: 28 }) : groups.map(group => {
                var _a;
                const rules = getCompulsoryServiceRules(group.current.compulsoryService);
                const classId = rules.serviceClassId.toString();
                return (React.createElement("div", { key: classId, className: "mb-3" },
                    React.createElement("h4", null, rules.name),
                    React.createElement(RadioGroup, { value: (_a = selected[classId]) !== null && _a !== void 0 ? _a : group.originalKey, onChange: e => setSelected(x => (Object.assign(Object.assign({}, x), { [classId]: e.target.value }))) }, group.choices.map(choice => (React.createElement(FormControlLabel, { key: getChoiceKey(choice), value: getChoiceKey(choice), control: React.createElement(Radio, { color: "primary" }), label: `${choice.validOn} - ${choice.name} - ${choice.price} ${choice.currency}` }))))));
            })),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: () => setOpen(false), disabled: saving }, _T.COMMON_CLOSE || 'Закрыть'),
                React.createElement(Button, { onClick: save, color: "primary", variant: "contained", disabled: loading || saving || !groups.length }, saving ? React.createElement(CircularProgress, { size: 20 }) : (_T.COMMON_SAVE || 'Сохранить'))))));
}
export function HotelService(props) {
    const cartOrder = useCartOrder();
    const { service } = props;
    const useExtendedCartPageDesign = !!props.cart.configuration.useExtendedCartPageDesign;
    const hotelPageUrl = getHotelDescriptionPageUrl(service.hotelDescription, props.cart.configuration);
    const compulsoryServices = useMemo(() => props.compulsoryServices.filter(x => { var _a; return !!((_a = getCompulsoryServiceRules(x.compulsoryService)) === null || _a === void 0 ? void 0 : _a.name); }), [props.compulsoryServices]);
    const errors = useMemo(() => { var _a, _b; return (_b = (_a = cartOrder.errors.serviceErrors) === null || _a === void 0 ? void 0 : _a.filter(e => e.serviceId === service.id).map(e => (e.serviceId === undefined ? undefined : e.touristIdx === undefined ? { field: e.field } : { field: e.field, touristIdx: e.touristIdx }))) !== null && _b !== void 0 ? _b : []; }, [cartOrder.errors.serviceErrors]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "table-responsive" },
            React.createElement("div", { className: "ajax-replace" },
                React.createElement("table", { className: "table order-table hotel-order-table" },
                    props.index == 0 ?
                        React.createElement("thead", null,
                            React.createElement("tr", null,
                                React.createElement("th", { className: "tour-order-table-tourname" },
                                    React.createElement("span", { className: "order-table-icon order-table-icon-hotel", "aria-hidden": "true" }),
                                    " ",
                                    _T.COMMON_STAY),
                                React.createElement("th", null, _T.COMMON_CHECKIN),
                                React.createElement("th", null, _T.COMMON_CHECKOUT),
                                React.createElement("th", null, _T.COMMON_HOTELROOM),
                                React.createElement("th", null, _T.COMMON_MEAL),
                                React.createElement("th", null, _T.BOOKING_TOTAL_PRICE),
                                React.createElement("th", null, _T.COMMON_PERSONCOUNT),
                                React.createElement("th", { className: "order-status" }, _T.COMMON_AVAILABILITY))) : null,
                    React.createElement("tbody", null,
                        React.createElement("tr", { className: `order-info ajax-replace service${props.service.id} service`, id: `hotelServiceRow${props.service.id}`, "data-service-id": props.service.id },
                            React.createElement("td", { className: "order-excur-name" },
                                React.createElement("span", { className: "order-hotel" }, hotelPageUrl ? React.createElement("a", { href: hotelPageUrl, target: "_blank", rel: "noopener noreferrer" }, service.hotel.name) : service.hotel.name),
                                " ",
                                service.hotel.city.name,
                                ", ",
                                service.hotel.city.country.name),
                            React.createElement("td", { className: "td-order-hotel-date-start" },
                                moment(service.begin).format('L'),
                                React.createElement("span", { className: "text-grey text-uppercase" }, moment(service.begin).format("ddd"))),
                            React.createElement("td", { className: "td-order-hotel-date-end" },
                                moment(service.end).format('L'),
                                React.createElement("span", { className: "text-grey text-uppercase" }, moment(service.end).format("ddd"))),
                            React.createElement("td", { className: "td-order-hotel-room" },
                                React.createElement("span", { className: "text-uppercase" },
                                    React.createElement("b", null, getRoomDisplayName(service.hotelPrice.originalRoomName, service.hotelPrice.roomType.name, service.hotelPrice.roomCategory.name))),
                                React.createElement("span", { className: "text-grey" },
                                    service.accommodation.adults,
                                    " ",
                                    _T.COMMON_ADULT_SHORT,
                                    " ",
                                    service.accommodation.childs > 0 ? React.createElement(React.Fragment, null,
                                        service.accommodation.childs,
                                        " ",
                                        _T.COMMON_CHILD_SHORT) : null)),
                            React.createElement("td", { className: "td-order-hotel-meal" }, service.hotelPrice.meal.name),
                            React.createElement("td", { className: "td-order-hotel-price" },
                                formatMoney(service.priceInBookingCurrency, { currency: props.cart.booking.currency.name }),
                                " ",
                                props.cart.booking.currency.name),
                            React.createElement("td", { className: "td-order-hotel-person" },
                                service.accommodation.adults + service.accommodation.childs,
                                " ",
                                pluralizeAutoSplit(service.accommodation.adults + service.accommodation.childs, _T.COMMON_PERSONS)),
                            React.createElement("td", { className: `order-status ${service.hotelPrice.immediateConfirm ? 'immediate' : 'request'}` }, service.hotelPrice.immediateConfirm ? _T.ROOM_AVAILABLE : _T.ROOM_ONREQUEST)),
                        React.createElement("tr", { className: `order-info-bottom service${service.id}` },
                            React.createElement("td", null),
                            React.createElement("td", { colSpan: 6 }),
                            React.createElement("td", { className: "order-del-bottom" },
                                React.createElement("a", { href: "#", className: "link delete-service", "data-service-id": service.id, onClick: () => props.deleteService(service.id) }, _T.BOOKING_DELETE_SERVICE))),
                        compulsoryServices.length ? React.createElement(React.Fragment, null,
                            React.createElement("tr", { className: "spanner", "data-compsvc-part": service.serviceTag },
                                React.createElement("td", { colSpan: 8 })),
                            React.createElement("tr", { className: "compulsory-services-header", "data-compsvc-part": service.serviceTag },
                                React.createElement("td", null, _T.HOTEL_COMPULSORY_SERVICES),
                                React.createElement("td", { colSpan: 2 }, _T.COMMON_DATE),
                                React.createElement("td", { colSpan: 2 }, _T.COMMON_SERVICE),
                                React.createElement("td", null, _T.HOTEL_COMPULSORY_SERVICE_PRICE),
                                React.createElement("td", { colSpan: 2 }, _T.COMMON_PERSONCOUNT)),
                            compulsoryServices.map(compSvc => {
                                var _a;
                                const rules = getCompulsoryServiceRules(compSvc.compulsoryService);
                                return (React.createElement("tr", { key: `${compSvc.serviceTag}-${rules.serviceClassId}`, id: `compulsory-service-${compSvc.serviceTag}-${rules.serviceClassId}`, className: "compulsory-services-body ajax-replace", "data-compsvc-part": service.serviceTag },
                                    React.createElement("td", null, "\u00A0"),
                                    React.createElement("td", { colSpan: 2 }, moment(compSvc.begin).format('L')),
                                    React.createElement("td", { colSpan: 2 },
                                        rules.name,
                                        ' ',
                                        ((_a = service.hotelPrice.compulsoryServices) !== null && _a !== void 0 ? _a : []).filter(x => { var _a; return ((_a = getCompulsoryServiceRules(x)) === null || _a === void 0 ? void 0 : _a.serviceClassId) == rules.serviceClassId; }).length > 1
                                            ? React.createElement(HotelCompulsoryServicesDialog, { hotelService: service, compulsoryServices: compulsoryServices, cart: props.cart })
                                            : null),
                                    React.createElement("td", null,
                                        formatMoney(compSvc.priceInBookingCurrency, { currency: props.cart.booking.currency.name }),
                                        " ",
                                        props.cart.booking.currency.name),
                                    React.createElement("td", { colSpan: 2 },
                                        compSvc.accommodation.adults + compSvc.accommodation.childs,
                                        " ",
                                        pluralizeAutoSplit(compSvc.accommodation.adults + compSvc.accommodation.childs, _T.COMMON_PERSONS))));
                            })) : null)))),
        useExtendedCartPageDesign ? (React.createElement("div", { className: `arrived service${service.id}` },
            React.createElement(ServiceTouristsBlock, { cart: props.cart, service: service, onTouristChange: props.onTouristChange }))) : (React.createElement(React.Fragment, null,
            React.createElement("a", { href: `#moreInfo${service.id}`, className: `tourist-list orange-collapse-link collapse service${service.id} d-block`, "data-toggle": "collapse", "aria-expanded": "false", "aria-controls": `moreInfo${service.id}` },
                React.createElement("span", { className: "caret-control" }, _T.BOOKING_TOURIST_DATA_ENTER)),
            React.createElement("div", { className: `arrived collapse service${service.id}`, id: `moreInfo${service.id}` },
                React.createElement(ServiceTouristsBlock, { cart: props.cart, service: service, onTouristChange: props.onTouristChange })))),
        React.createElement("a", { href: `#dopInfo${service.id}`, className: `orange-collapse-link-2 service${service.id}`, "data-toggle": "collapse", "aria-expanded": "false", "aria-controls": `dopInfo${service.id}` },
            React.createElement("span", { className: "caret-control" }, _T.COMMON_ADDITIONAL_REQUIREMENTS)),
        React.createElement("div", { className: `collapse dop-info service${service.id}`, id: `dopInfo${service.id}` },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-6 col-xs-12" },
                    React.createElement("div", { className: "form-grop" },
                        React.createElement("textarea", { className: "form-control add-req", maxLength: 250, rows: 4, cols: 4, onChange: e => props.onServiceChange(props.service.id, { additionalRequirements: e.target.value }) }, service.additionalRequirements))),
                React.createElement("div", { className: "col-md-4 col-xs-12" },
                    React.createElement("p", null,
                        "* ",
                        _T.COMMON_ADDITIONAL_REQUIREMENTS_COMMENT))))));
}
